

import React, { useCallback } from 'react'
import styled from 'styled-components'
import { ButtonYellowLight } from '../../Button'
import useModal from '../../../hooks/bakery/useModal'
import { stopPropagation } from '../../../utils/func'
import TransferModal from '../../../pages/BakeryArtworks/components/TransferModal'
import { useActiveWeb3React } from '../../../hooks'


const Button = styled(ButtonYellowLight)`
  border: 1px solid #FF7A00;
  background-color: ${({ theme }) => theme.btnBg3};
  WebkitBackgroundClip: 'text',
  color: 'transparent';
  font-family: 'Roboto-Regular';
  height: 40px;
  margin-left: 16px;
`

export default function TransferBtn ({artwork, marketType}: {artwork: any, marketType: string}) {
  const { account } = useActiveWeb3React()

  const [artworkTransferExchange] = useModal(
    <TransferModal
      tokenId={artwork.tokenId}
      title="Input the Address"
      type={marketType}
    />,
  )

  const onPresentExchange = useCallback(async (event) => {
    event.preventDefault()
    stopPropagation(event)
    artworkTransferExchange()
  }, [artworkTransferExchange])

  return(
    <Button
      disabled={(artwork.price || (account && artwork.owner && artwork.owner.toLowerCase() !== account.toLowerCase())) ? true : false}
      onClick={event => {onPresentExchange(event)}}
      altDisabledStyle={artwork.price ? true : false}
    >
      Transfer
    </Button>
  )
}